import { getMenuByRole } from '../lib/menuItems';

export const getHighestAvailableUrl = (userRole) => {
  const menu = getMenuByRole(userRole);

  if (!menu?.length) {
    return null;
  }

  const firstMenuItem = menu[0];

  if (firstMenuItem.items?.length) {
    return firstMenuItem.items[0]?.link || null;
  }

  return firstMenuItem.link || null;
};

export const hasAccessToUrl = (userRole, url) => {
  const menu = getMenuByRole(userRole);

  if (!menu?.length || !url) {
    return false;
  }

  const checkItems = (items) => {
    return items.some((item) => {
      if (item.link === url) {
        return true;
      }

      if (item.items?.length) {
        return checkItems(item.items);
      }

      return false;
    });
  };

  return checkItems(menu);
};
